import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = {
  key: 0,
  class: "row items-center no-wrap q-gutter-xs"
}
const _hoisted_3 = {
  key: 1,
  class: "text-grey font-caption"
}

import { computed, ref } from 'vue';

import FieldFileSigningActions from 'SharedComponents/Fields/FieldFileSigningActions.vue';
import { BaseFieldEmits } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import { ViewFieldProps } from 'SharedComponents/Fields/composables/useViewField';
import useFileApi from 'SharedDir/common/composables/useFileApi';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { FieldFile } from 'SharedDir/declarations/fields';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FileValue' },
  __name: 'FileValue',
  props: {
    modelValue: {},
    label: {},
    showHistory: { type: Boolean },
    history: {}
  },
  emits: ["reveal-history"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emits = __emit;
const file = computed(() => props.modelValue || null);
const { downloadFile } = useFileApi();
const loading = ref(false);
const download = () => {
  makeRequest(() => downloadFile(file.value?.fileId), {
    startLoading: () => {
      loading.value = true;
    },
    finishLoading: () => {
      loading.value = false;
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    _createElementVNode("figcaption", null, _toDisplayString(_ctx.label), 1),
    (file.value.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("span", {
            class: "s-link",
            onClick: download
          }, [
            _createVNode(_component_q_icon, {
              size: "1.5em",
              name: "attachment",
              class: _normalizeClass({ shaking: loading.value })
            }, null, 8, ["class"]),
            _createTextVNode(" " + _toDisplayString(file.value.value), 1)
          ]),
          (file.value.fileId)
            ? (_openBlock(), _createBlock(FieldFileSigningActions, {
                key: 0,
                "file-id": file.value.fileId,
                "file-name": file.value.value || ''
              }, null, 8, ["file-id", "file-name"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, " Вложение отсутствует "))
  ]))
}
}

})